import { ReactNode } from "react";
import { NotReadyTutorialStatus } from "./components/TutorialCard";

export type Tutorial = {
  status: "ready";
  titleKey: string;
  // youtube.com or veed.io — the provider is detected from the url.
  videoUrl: string;
  // Local file in public/ so the page never calls YouTube/veed before a click.
  thumbnailUrl: string;
};

export type NotReadyMockTutorial = {
  status: NotReadyTutorialStatus;
  titleKey: string;
  descriptionKey: string;
  icon: ReactNode;
};

// Hardcoded until we have a tutorials CMS/endpoint. Source: the "Libertify
// Video Tutorials" and "Libertify Education Tutorials" YouTube playlists.
// Order mirrors the YouTube playlists — sync with the update-tutorials skill.
type TutorialEntry = [titleKey: string, videoUrl: string, thumbnailUrl: string];

const EDUCATION_TUTORIAL_ENTRIES: ReadonlyArray<TutorialEntry> = [
  [
    "pages.tutorials.items.teacherDna.title",
    "https://www.youtube.com/watch?v=s5Ly-QZlGTk",
    "/images/tutorials/teacherDna.jpg",
  ],
  [
    "pages.tutorials.items.studentOnboarding.title",
    "https://www.youtube.com/watch?v=2El_j_ALcic",
    "/images/tutorials/studentOnboarding.jpg",
  ],
  [
    "pages.tutorials.items.documents.title",
    "https://www.youtube.com/watch?v=UYC2U866hX0",
    "/images/tutorials/documents.jpg",
  ],
];

const VIDEO_TUTORIAL_ENTRIES: ReadonlyArray<TutorialEntry> = [
  [
    "pages.tutorials.items.experiencesList.title",
    "https://www.youtube.com/watch?v=CMCpYCCPVeM",
    "/images/tutorials/experiencesList.jpg",
  ],
  [
    "pages.tutorials.items.playbook.title",
    "https://www.youtube.com/watch?v=UpemHm_wPXs",
    "/images/tutorials/playbook.jpg",
  ],
  [
    "pages.tutorials.items.quizAddon.title",
    "https://www.youtube.com/watch?v=WsbIaQIYPNI",
    "/images/tutorials/quizAddon.jpg",
  ],
  [
    "pages.tutorials.items.brandkit.title",
    "https://www.youtube.com/watch?v=kNvKCn-_zJE",
    "/images/tutorials/brandkit.jpg",
  ],
  [
    "pages.tutorials.items.editVideo.title",
    "https://www.youtube.com/watch?v=bImee3kT1IA",
    "/images/tutorials/editVideo.jpg",
  ],
  [
    "pages.tutorials.items.avatar.title",
    "https://www.youtube.com/watch?v=ztgJmjwAvsc",
    "/images/tutorials/avatar.jpg",
  ],
  [
    "pages.tutorials.items.addOns.title",
    "https://www.youtube.com/watch?v=kdOKfCJEXPI",
    "/images/tutorials/addOns.jpg",
  ],
  [
    "pages.tutorials.items.videoAddon.title",
    "https://www.youtube.com/watch?v=mtW9VuCAHao",
    "/images/tutorials/videoAddon.jpg",
  ],
  [
    "pages.tutorials.items.analytics.title",
    "https://www.youtube.com/watch?v=uvmh0n_Hk4Y",
    "/images/tutorials/analytics.jpg",
  ],
  [
    "pages.tutorials.items.callToAction.title",
    "https://www.youtube.com/watch?v=muWTZWx8eTQ",
    "/images/tutorials/callToAction.jpg",
  ],
  [
    "pages.tutorials.items.navigateExperience.title",
    "https://www.youtube.com/watch?v=-breM2i3CEA",
    "/images/tutorials/navigateExperience.jpg",
  ],
  [
    "pages.tutorials.items.keyPointsAddon.title",
    "https://www.youtube.com/watch?v=o01F70hByuk",
    "/images/tutorials/keyPointsAddon.jpg",
  ],
];

const toTutorials = (entries: ReadonlyArray<TutorialEntry>): Tutorial[] =>
  entries.map(([titleKey, videoUrl, thumbnailUrl]) => ({
    status: "ready",
    titleKey,
    videoUrl,
    thumbnailUrl,
  }));

export const EDUCATION_TUTORIALS = toTutorials(EDUCATION_TUTORIAL_ENTRIES);
export const VIDEO_TUTORIALS = toTutorials(VIDEO_TUTORIAL_ENTRIES);

// Empty since every planned lesson now has a published video — kept so the
// next unreleased tutorial can be announced without rebuilding the section.
export const NOT_READY_TUTORIALS: NotReadyMockTutorial[] = [];
